module.exports = __webpack_public_path__ + "img/logo.94c32989.png";